import { AxiosResponse } from 'axios';
import APIService from './base.service';
import { IProduct, IUpdateProduct, ProductQueryParams } from '@/interfaces';
import { QueryFunctionContext } from '@tanstack/react-query';
import { QueryKeyType } from '@/types';

const basePath = '/products';
export default class ProductService {
  static getAll(params: ProductQueryParams): Promise<AxiosResponse> {
    return APIService.get(basePath, { params });
  }

  static getProducts({
    queryKey: [_, params],
  }: QueryFunctionContext<
    QueryKeyType<string, ProductQueryParams>
  >): Promise<AxiosResponse> {
    return APIService.get(basePath, { params });
  }

  static getProduct({
    queryKey: [id],
  }: QueryFunctionContext<string[]>): Promise<AxiosResponse> {
    return APIService.get(basePath + `/${id}`);
  }

  static async getExportProducts(
    params: ProductQueryParams,
  ): Promise<AxiosResponse> {
    return APIService.get(basePath + '/export-data', { params });
  }

  static deleteProduct(id: string): Promise<AxiosResponse> {
    return APIService.delete(basePath + `/${id}`);
  }

  static deleteProducts(ids: string[]): Promise<AxiosResponse> {
    return APIService.delete(basePath, { data: { ids } });
  }

  static restoreProduct(id: string): Promise<AxiosResponse> {
    return APIService.patch(basePath + `/${id}`, { active: true });
  }

  static restoreProducts(params: { ids: string[] }): Promise<AxiosResponse> {
    return APIService.patch(basePath, params);
  }

  static deactivateProduct(id: string): Promise<AxiosResponse> {
    return APIService.patch(basePath + `/${id}`, { active: false });
  }

  static deactivateProducts(params: { ids: string[] }): Promise<AxiosResponse> {
    return APIService.patch(basePath, params);
  }

  static createProduct(payload: IProduct): Promise<AxiosResponse> {
    return APIService.post(basePath, payload);
  }

  static updateProduct(
    payload: IUpdateProduct & { id: string },
  ): Promise<AxiosResponse> {
    const { id, ...newPayload } = payload;
    return APIService.put(
      basePath + `/${payload.id}/with-sub-products`,
      newPayload,
    );
  }

  static fetchProductOptions(
    params: ProductQueryParams,
  ): Promise<AxiosResponse> {
    return APIService.get(basePath, { params });
  }
}
